import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import accessUtils from '../utils/accessUtils';
import { ModularListingContext } from '../containers/CreateListingPage/context';

/**
 * Determines access to ZRM tour scheduling posting path integration
 *
 * @returns { canAccessZRMTourScheduling }
 */
const useAccessPostingPathTourScheduling = () => {
  const {
    // @ts-expect-error
    properties: { currentProperty },
  } = useSelector((state) => state);

  const { modularListingState } = useContext(ModularListingContext);
  const isInReactivationFlow = modularListingState?.isInReactivationFlow || false;

  const canAccessPostingPathTourScheduling = useMemo(() => {
    if (!currentProperty) {
      return false;
    }

    return accessUtils.isTourSchedulingEnabledForProperty({
      currentProperty,
      isInReactivationFlow,
    });
  }, [currentProperty, isInReactivationFlow]);

  return {
    canAccessPostingPathTourScheduling,
  };
};

export default useAccessPostingPathTourScheduling;
